/* NorDerm cookie consent manager — Google Consent Mode v2 compliant.
   Loaded synchronously in <head>, before any analytics tag, so
   gtag('consent','default', ...) always runs first. GA4/GTM is only
   injected after the visitor actively grants the "statistikk" category —
   it never fires on page load by default. */
window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
  wait_for_update: 500
});

(function () {
  var CONSENT_KEY = 'norderm_consent';
  var CONSENT_VERSION = 1;

  /* Fill in once Google Tag Manager / GA4 has been set up in the merchant's
     own Google account (see NorDerm_Notat_til_utvikler.md §4). Until then
     this stays a placeholder and no analytics script is ever requested. */
  var GTM_ID = 'GTM-XXXXXXX';

  function readConsent() {
    try {
      var raw = localStorage.getItem(CONSENT_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.version === CONSENT_VERSION) return parsed;
      return null;
    } catch (e) { return null; }
  }

  function writeConsent(analytics) {
    var record = {
      version: CONSENT_VERSION,
      necessary: true,
      analytics: !!analytics,
      timestamp: new Date().toISOString()
    };
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify(record)); } catch (e) {}
    try {
      document.cookie = CONSENT_KEY + '=' + encodeURIComponent(JSON.stringify(record)) +
        '; max-age=' + (365 * 24 * 3600) + '; path=/; SameSite=Lax';
    } catch (e) {}
    return record;
  }

  function loadGtm() {
    if (!GTM_ID || GTM_ID.indexOf('XXXXXXX') !== -1) return;
    if (window.__nordermGtmLoaded) return;
    window.__nordermGtmLoaded = true;
    gtag('event', 'gtm.js', { 'gtm.start': new Date().getTime() });
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
    document.head.appendChild(s);
  }

  /* Push the decision into Shopify's own consent system (Customer Privacy
     API). This is what actually gates Shopify-managed tracking — its
     analytics, marketing pixels and checkout — based on what the visitor
     chose. Without this call the banner would only control our own GA4 and
     leave Shopify's cookies ungoverned. Available on the Online Store via
     window.Shopify.loadFeatures. */
  function syncShopifyConsent(record) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    var analytics = !!(record && record.analytics);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      if (!window.Shopify.customerPrivacy || typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') return;
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: analytics,
        marketing: false,
        preferences: false,
        sale_of_data: false
      }, function () {});
    });
  }

  function applyConsent(record) {
    var granted = !!(record && record.analytics);
    gtag('consent', 'update', {
      analytics_storage: granted ? 'granted' : 'denied'
    });
    if (granted) loadGtm();
    syncShopifyConsent(record);
  }

  var existing = readConsent();
  if (existing) applyConsent(existing);

  function buildUI() {
    var root = document.createElement('div');
    root.id = 'norderm-consent-root';
    root.innerHTML =
      '<div class="nc-banner" id="nc-banner" role="dialog" aria-live="polite" aria-label="Informasjonskapsler" hidden>' +
        '<div class="nc-banner-inner">' +
          '<p class="nc-text">Vi bruker informasjonskapsler for å få nettsiden til å fungere, og — kun med ditt samtykke — for anonymisert statistikk. Les mer i vår <a href="' + (window.NordermPages && window.NordermPages.cookies || '/pages/cookies') + '">cookie-erklæring</a>.</p>' +
          '<div class="nc-actions">' +
            '<button type="button" class="nc-btn nc-btn-ghost" id="nc-settings-btn">Innstillinger</button>' +
            '<button type="button" class="nc-btn nc-btn-outline" id="nc-reject-btn">Avvis alle</button>' +
            '<button type="button" class="nc-btn nc-btn-primary" id="nc-accept-btn">Godta alle</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="nc-overlay" id="nc-modal-overlay" hidden>' +
        '<div class="nc-modal" role="dialog" aria-modal="true" aria-labelledby="nc-modal-title">' +
          '<h2 id="nc-modal-title">Cookie-innstillinger</h2>' +
          '<div class="nc-row">' +
            '<div class="nc-row-text"><strong>Nødvendige</strong><span>Kreves for at innlogging, handlekurv og sikkerhet skal fungere. Kan ikke slås av.</span></div>' +
            '<label class="nc-switch nc-switch-locked"><input type="checkbox" checked disabled><span class="nc-slider"></span></label>' +
          '</div>' +
          '<div class="nc-row">' +
            '<div class="nc-row-text"><strong>Analyse</strong><span>Pseudonymisert trafikkanalyse (Google Analytics 4). Av som standard.</span></div>' +
            '<label class="nc-switch"><input type="checkbox" id="nc-analytics-toggle"><span class="nc-slider"></span></label>' +
          '</div>' +
          '<div class="nc-modal-actions">' +
            '<button type="button" class="nc-btn nc-btn-outline" id="nc-modal-reject">Avvis alle</button>' +
            '<button type="button" class="nc-btn nc-btn-primary" id="nc-modal-save">Lagre valg</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    var banner = document.getElementById('nc-banner');
    var overlay = document.getElementById('nc-modal-overlay');
    var analyticsToggle = document.getElementById('nc-analytics-toggle');

    function hideBanner() { banner.hidden = true; }
    function showBanner() { banner.hidden = false; }
    function closeModal() { overlay.hidden = true; document.body.style.overflow = ''; }
    function openModal() {
      var current = readConsent();
      analyticsToggle.checked = !!(current && current.analytics);
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    document.getElementById('nc-accept-btn').addEventListener('click', function () {
      applyConsent(writeConsent(true));
      hideBanner();
    });
    document.getElementById('nc-reject-btn').addEventListener('click', function () {
      applyConsent(writeConsent(false));
      hideBanner();
    });
    document.getElementById('nc-settings-btn').addEventListener('click', openModal);
    document.getElementById('nc-modal-reject').addEventListener('click', function () {
      applyConsent(writeConsent(false));
      closeModal();
      hideBanner();
    });
    document.getElementById('nc-modal-save').addEventListener('click', function () {
      applyConsent(writeConsent(analyticsToggle.checked));
      closeModal();
      hideBanner();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    /* Cookie consent on this Shopify Online Store is handled by Shopify's own
       native consent banner (Settings → Customer privacy). The Customer
       Privacy API that actually gates Shopify's tracking is only shipped to
       the storefront through that native banner — a fully custom banner can't
       drive it — so we do NOT auto-show our own banner (that would duplicate
       Shopify's). This module stays only to (a) hold Google Consent Mode
       defaults for a future GA4/GTM tag and (b) expose a preferences modal for
       the footer "Cookie-innstillinger" link. */
    if (existing) {
      syncShopifyConsent(existing);
    }

    window.NordermConsent = {
      open: openModal,
      getConsent: readConsent,
      reset: function () {
        try { localStorage.removeItem(CONSENT_KEY); } catch (e) {}
        showBanner();
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildUI);
  } else {
    buildUI();
  }
})();
